import Marquee from "react-fast-marquee";

const WORDS = ["BANHOS", "TOSQUIAS", "GROOMING", "FERNÃO FERRO", "CARINHO"];

export const EditorialMarquee = () => {
  return (
    <section data-testid="marquee-section" className="py-8 md:py-12 border-y border-[#0A0A0A] bg-cream select-none">
      <Marquee speed={55} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-black text-[11vw] md:text-[7vw] leading-none text-stroke tracking-tightest px-6">
              {w}
            </span>
            <span className="text-magenta text-4xl md:text-6xl px-2">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
